import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import sideOptions from '../Side/SideOptions';
import { Link } from "react-router-dom";

export default class SearchNavigator extends Component {

  constructor(props) {
    super(props);
    this.state = {
      options: []
    };
    this.getOptions(sideOptions);
  }

  getOptions(options = []) {
    for (const option of options) {
      if (option.children) {
        this.getOptions(option.children)
      }
      if (option.link) {
        this.state.options.push(option);
      }
    }
  }

  onKeyUp = (event) => {
    if (event.keyCode === 13) {
      this.props.history.push(event.target.value);
      this.props.onSelect();
    }
  }

  render() {
    return (
      <React.Fragment>
        <div style={{
          position: 'absolute',
          zIndex: 10,
          backgroundColor: '#00000044',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
        }} onClick={() => this.props.onSelect()}></div>
        <div
          style={{
            top: '10%',
            left: 0,
            right: 0,
            margin: '0 auto',
            position: 'absolute',
            width: '90%',
            // height: '85px',
            padding: 20,
            backgroundColor: 'white',
            border: '1px black',
            display: 'flex',
            zIndex: 1000
          }} >
          <Autocomplete
            ref={this.myRef}
            style={{ width: '100%' }}
            id="free-solo-demo"
            onKeyUp={this.onKeyUp}
            options={this.state.options}
            getOptionLabel={option => option.link}
            renderInput={params => (
              <TextField
                {...params}
                autoFocus={true}
                label="Navegacion"
                margin="normal"
                variant="outlined"
                fullWidth />
            )}
            renderOption={(option) => {
              return (
                <Link to={option.link} >
                  {option.label}
                </Link>
              )
            }}
          />
        </div>
      </React.Fragment>
    )
  }
}
